<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('shippingDeleteDialog.label.title') }}</strong></h3>
      </v-card-title>

      <v-card-text class="pa-4 pre-line grey--text text--darken-4 text-subtitle-1 px-5">
        <p class="mb-4">{{ $t('shippingDeleteDialog.message.remarks') }}</p>
        <p class="mb-4">{{ $t('shippingDeleteDialog.message.confirm') }}</p>
        <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="staffCode"
          :label="$t('shippingDeleteDialog.label.staffCode')" :counter="staffCodeMaxLength"
          :maxLength="staffCodeMaxLength" :disabled="isLoading" :rules="[rules.checkStaffCode]" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="this.handleClose(false)" :disabled="isLoading"> {{ $t('common.action.cancel') }} </v-btn>
        <v-btn color="indigo darken-1" dark @click="register" :loading="isLoading" :disabled="invalidInput">
          {{ $t('common.action.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <MessageDialog v-if="messageDialogVisible" :dialog-data="messageDialogData" :handle-ok="closeMessageDialog" />
</template>

<script>
import Vue from 'vue';
import api from "@/apis/staff";
import constant from "@/utils/constant"
import store from "@/store";
import utils from "@/utils";
import MessageDialog from "@/components/dialog/MessageDialog";

export default {
  components: { MessageDialog },
  props: {
    handleClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    invalidInput() {
      if (!utils.isValidStaffCode(this.staffCode)) return true;
      return this.staffCode.length == 0 || this.staffCode.length > this.staffCodeMaxLength;
    },
  },
  data() {
    return {
      dialog: true,
      staffCode: "",
      staffCodeMaxLength: 0,
      isLoading: false,
      rules: {
        checkStaffCode: v => {
          return utils.isValidStaffCode(v) || this.$t('shippingDeleteDialog.validation.halfAlnum');
        },
      },
      // メッセージダイアログ
      messageDialogVisible: false,
      messageDialogData: {
        message: "",
        errorList: [],
      },
    };
  },
  methods: {
    /** メッセージの表示 */
    showMessage(message) {
      this.messageDialogData.message = message;
      this.messageDialogVisible = true;
    },
    /** リクエスト作成 */
    makeRequest() {
      return {
        denpyoNumber: store.getShukkaDenpyoNumber(),
        staffId: this.staffCode,
        planAndActualStatus: store.getShukkaPlanAndActualStatus(),
      };
    },
    /** API実行 */
    async register() {
      this.isLoading = true;
      let message = this.$t('shippingDeleteDialog.message.success');
      try {
        const response = await api.post("/shukka/correct/delete", this.makeRequest());
        // 基本的に入力エラーは発生せず、整合性エラーが発生する
        // 汎用的なエラーメッセージを出した後、実績画面で再検索させることでエラーを解消させる
        if (response.data?.status != 0) throw "";
      } catch (e) {
        message = this.$t('common.message.errorAndRetry');
      } finally {
        this.isLoading = false;
      }
      this.showMessage(message);
    },
    /** 成功メッセージダイアログを閉じる */
    closeMessageDialog() {
      this.messageDialogVisible = false;
      this.handleClose(true);
    },
  },
  mounted() {
    this.staffCodeMaxLength = constant.STAFF_CODE_MAX_LENGTH;
  },
};
</script>
<style>
.pre-line {
  white-space: pre-line;
}
</style>
